import React, { useEffect } from 'react'
import { useStores } from "../../stores/rootStore";
import { QARFormWrapper } from './wrapper';
import { observer } from "mobx-react";
import "./index.css"


export const QARForm = observer(() => {

  const { qarFormStore, userStore } = useStores();

  // init point
  useEffect(() => {

    async function fetchEmployees() {
      await qarFormStore.loadFormData(currentUserID, null);
    }

    const currentUserID = userStore.currentUserID;
    if (currentUserID !== undefined) {
      qarFormStore.loadAllManagers();
      fetchEmployees();
    }

    // this shouyld be called only once on init
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStore.currentUserID]);

  return (
    // <QARFormManagerInfo></QARFormManagerInfo>
    <QARFormWrapper></QARFormWrapper>
  );

});